import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReturnsComponent } from './returns.component';
import { PageTitle } from '../store-front/misc/page-title/page-title.component';
import { AuthGuard, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { FormErrorsModule } from '@spartacus/storefront';
import { ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '@spartacus/organization/administration/components';
import { LocalLoaderComponent } from '../../../components/loader/local-loader/local-loader.component';
import { TableProComponent } from '../../../components/table-pro/table-pro.component';
import { DatePickerModule } from 'primeng/datepicker';
import { returnsOccConfig } from './core/return.occ';
import { ReturnService } from './core/return.service';
import { AllowedKeysToDatePickerModule } from '../../../core/directives/allowed-keys-to-date-picker/allowed-keys-to-date-picker.module';

@NgModule({
  declarations: [ReturnsComponent],
  imports: [
    CommonModule,
    PageTitle,
    I18nModule,
    FormModule,
    RouterModule,
    FormErrorsModule,
    DatePickerModule,
    ReactiveFormsModule,
    LocalLoaderComponent,
    TableProComponent,
    AllowedKeysToDatePickerModule,
  ],
  providers: [
    ReturnService,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ReturnsPageComponent: {
          component: ReturnsComponent,
          guards: [AuthGuard],
        },
      },
    }),
    provideConfig(returnsOccConfig),
    provideConfig({
      routing: {
        routes: {
          returnsPage: { paths: ['my-account/returns'] },
        },
      },
    }),
  ],
})
export class ReturnsModule {}
